import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';

export function Spinner({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      role="status"
      aria-label={t('common.loading')}
      className={cn('inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent', className)}
    />
  );
}
